import { TweenLite, Power2 } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import imagesLoaded from 'vue-images-loaded'
import Vue from 'vue'

const pageArrowMixin = {
    data() {
        return {
            isOnBottom: false,
        }
    },

    methods: {
        handleArrowScroll() {
            let page = document.documentElement
            let pageHeight = page.scrollHeight - page.clientHeight
            let scrollY = window.scrollY

            if ( scrollY >= pageHeight && pageHeight !== 0 ) {
                this.isOnBottom = true
            }
            else {
                this.isOnBottom = false
            }
        },

        onFixedArrowClick() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            // if ( this.isOnBottom ) {
                // TweenLite.to( window, .5, {
                //     scrollTo: 0
                // } )
            // }
            // else {
            //     TweenLite.to( window, .5, {
            //         scrollTo: window.scrollY + document.documentElement.clientHeight,
            //     } )
            // }
        },
    },

    mounted() {
        this.handleArrowScroll()
    },

    created() {
        window.addEventListener( 'scroll', this.handleArrowScroll )
        window.addEventListener( 'resize', this.handleArrowScroll )
    },

    destroyed() {
        window.removeEventListener( 'scroll', this.handleArrowScroll )
        window.removeEventListener( 'resize', this.handleArrowScroll )
    },
}

const globalMixin = {
    data() {
        return {
        }
    },

    directives: {
        imagesLoaded,
    },

    computed: {
        differentLanguage() {
            const locale = Vue.i18n.locale()
            return locale == 'ru' ? 'en' : 'ru'
        },
    },

    methods: {
        onChangeLanguage() {
            const locale = Vue.i18n.locale()
            const newLocale = locale == 'ru' ? 'en' : 'ru'

            this.$router.push({
                name: 'lang',
                params: {
                    lang: newLocale,
                },
            });
        },

        getApiURL( url ) {
            return `${process.env.VUE_APP_API_URL}${url}`;
            // return `http://134.0.112.228:3000/api/${url}`
            // return `http://localhost:3000/api/${url}`
        },
        

        onFollowLink( to ) {
            const self = this

            if ( self.$router.currentRoute.name != to.name ) {
                this.onStartLoading( () => {
                    self.$router.push( to )
                } )
            }
            else {
                if ( to.name == 'projects' ) {
                    self.$router.push( to )
                }
            }
        },

        onStartLoading( callback ) {
            const pageChanger = document.getElementById('page-changer')
            const self = this

            pageChanger.style.display = 'block'
            TweenLite.fromTo( pageChanger, .5, {
                clip: `rect(0px, ${ window.innerWidth }px, ${ window.innerHeight }px, ${ window.innerWidth }px)`,
            }, {
                clip: `rect(0px, ${ window.innerWidth }px, ${ window.innerHeight }px, 0px)`,
                ease: Power2.easeInOut,
                onComplete() {
                    setTimeout( () => {
                        callback()
                    }, 100 )
                },
            } )
        },

        onPageLoaded() {
            const pageChanger = document.getElementById('page-changer')
            const self = this

            TweenLite.to( pageChanger, .5, {
                clip: `rect(0px, 0px, ${ window.innerHeight }px, 0px)`,
                ease: Power2.easeInOut,
                onComplete() {
                    pageChanger.style.display = 'none'
                },
            } )
        },

        onImageLoad( instance ) {
            this.onPageLoaded()
        }
    },
}

const scrollMixin = {
    data() {
        return {
            isOnTop: true,
            scrollHeaderVisible: false,
            isScrollingDown: true,
            lastScrollYPosition: 0,
        }
    },

    computed: {
        isMainMenuHidden() {
            if (this.$route.name === 'project') {
                return this.isScrollingDown;
            } else {
                return this.isScrollingDown && this.lastScrollYPosition > 50;
            }
        },

        isMainMenuBackgroundFilled() {
            if (this.$route.name !== 'project') {
                return this.lastScrollYPosition > 50;
            }
        },
    },
    
    methods: {
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },

        showScrollHeader() {
            this.scrollHeaderVisible = true
            this.$store.commit( 'setNavigationColor', 'black' )
            this.$store.commit( 'setLogoColor', 'black' )
        },

        hideScrollHeader() {
            this.scrollHeaderVisible = false
            if ( this.activeTab == 'team' ) {
                this.$store.commit( 'setNavigationColor', 'black' )
            }
            else {
                this.$store.commit( 'setNavigationColor', 'white' )
            }
        },

        handleScroll( isOnCreated ) {
            let page = document.documentElement
            let pageHeight = page.scrollHeight - page.clientHeight
            let scrollY = window.scrollY
            let percents = scrollY / ( pageHeight / 100 )

            let bar = this.$refs.progressBar
            if ( bar ) {
                TweenLite.set( bar, {
                    width: `${ percents }%`
                } )
            }

            let headerTrigger = this.$refs.projectTitle
            if ( headerTrigger ) {
                let show = false
                if ( scrollY > headerTrigger.offsetTop - 50 ) {
                    show = true
                }
                if ( show ) {
                    this.showScrollHeader();
                }
                else {
                    this.hideScrollHeader();
                }
            }

            this.isScrollingDown = this.lastScrollYPosition < scrollY;
            this.lastScrollYPosition = scrollY;

            /*if ( scrollY <= 0 ) {
                this.isOnTop = true
                if ( window.innerWidth > 768 ) {
                    if ( isOnCreated ) {
                        setTimeout( () => {
                            this.$store.commit( 'setLogoColor', 'white' )
                        } )
                    } else {
                        this.$store.commit( 'setLogoColor', 'white' )
                    }
                }
            }
            else {
                this.isOnTop = false
                this.$store.commit( 'setLogoColor', 'black' )
            }*/
        },
    },

    mounted() {
        this.$store.commit( 'setNavigationColor', 'black' )
        this.$store.commit( 'setLogoColor', 'white' )
        this.handleScroll( true )
    },

    created() {
        window.addEventListener( 'scroll', this.handleScroll )
        window.addEventListener( 'resize', this.handleScroll )
    },

    destroyed() {
        window.removeEventListener( 'scroll', this.handleScroll )
        window.removeEventListener( 'resize', this.handleScroll )
    },
}

export { scrollMixin, globalMixin, pageArrowMixin }